// submitAcquisitionCode.js
'use strict';
import fetch from '../resource/customFetch.js';
import getMeData from '../selector/getMeData.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import addModal from './addModal.js';
import pushToastr from './pushToastr.js';
import resetAcquisitionCode from '../action/resetAcquisitionCode.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  MERGE_OPERATION_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

const ERROR_CODE_PREFIX = 'acquisition_err_';
const ERROR_CODE_DEFAULT = 'error_code_not_valid';

/**
 * Submit exchange prepaid card
 * @kind action
 * @param {string} {code} - exchange code.
 * @return {Promise} Action promise.
 */
const submitAcquisitionCode =
  ({ code, type = 'prepaid' }) =>
  async (dispatch, getState) => {
    const token = getMeData(getState(), 'token');

    if (!code || !token) return dispatch({ type: '' });

    const networkingSelectPath = ['acquisition', code, 'redeem'];

    const fetchOptions = {
      method: 'PUT',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ code }),
    };

    const url = getResourceUrl({ endpoint: '/acquisition/redeem' });

    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });
    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      if (type === 'prepaid') {
        dispatch(
          addModal({ id: 'PrepaidCodeSuccessModal', isHigherThanAll: true })
        );
      } else {
        // Type prepaid will clean data on close
        dispatch(resetAcquisitionCode());
      }

      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath },
      });
    } catch (error) {
      let errorMessage = error.message;
      try {
        errorMessage = JSON.parse(error.message).code;
        // eslint-disable-next-line no-empty
      } catch (_) {}

      dispatch(resetAcquisitionCode());

      const errorI18nkey = errorMessage?.toLowerCase
        ? ERROR_CODE_PREFIX + errorMessage.toLowerCase()
        : ERROR_CODE_DEFAULT;
      // Display error message and incorrect code in input
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['acquisition'],
          data: {
            manual: {
              code,
            },
            amount: null,
            errorI18nkey,
          },
        },
      });

      dispatch(
        pushToastr({
          textKey: 'toast_redemption_failed',
          durationSec: 2,
          color: 'error',
        })
      );
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default submitAcquisitionCode;
